import { InstanceStatus } from '../../services/trainingApi';
import { Tag, Tone } from './ui';

const TONE: Record<InstanceStatus, Tone> = {
  running: 'ok',
  allocating: 'warn',
  starting: 'warn',
  stopping: 'off',
  stopped: 'off',
  terminated: 'off',
  error: 'err',
};

export default function InstanceStatusTag({ status }: { status: InstanceStatus }) {
  return (
    <Tag tone={TONE[status] ?? 'off'} className="capitalize">
      {status}
    </Tag>
  );
}
